import React from 'react'
import PropTypes from 'prop-types'
import InternationalizedFormattedText from '../util/internationalized-formatted-text'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  contentTitle: {
    paddingTop: theme.spacing(1),
  },
}))

const CardTitle = ({ text }) => {
  const classes = useStyles()

  return (
    <div>
      <InternationalizedFormattedText variant='h2' className={classes.contentTitle} id={text} />
    </div>
  )
}

CardTitle.propTypes = {
  text: PropTypes.string.isRequired,
}

export default CardTitle
